import { CloudUploadOutlined, CheckCircleOutlined, WarningOutlined, CloseCircleOutlined } from '@ant-design/icons';
import { Space, Typography, Tag } from 'antd';

import { DownloadViaLink } from '../../clientUtils';

const { Text, Link } = Typography;

const ICON_SIZE = { fontSize: 16 };

function UploadSummary({ fileUrl, summary }) {
  const { failure, success, total, warning } = summary || {};

  const tags = [
    {
      color: '#F4F6F9',
      icon: <CloudUploadOutlined style={ICON_SIZE} />,
      number: total,
      text: 'Total'
    },
    {
      color: '#F5FCF1',
      icon: <CheckCircleOutlined className="success_icon" style={ICON_SIZE} />,
      number: success,
      text: 'Passed'
    },
    {
      color: '#FFF8E5',
      icon: <WarningOutlined className="warning_icon" style={ICON_SIZE} />,
      number: warning,
      text: 'Warnings'
    },
    {
      color: '#FFECEC',
      icon: <CloseCircleOutlined style={ICON_SIZE} />,
      number: failure,
      text: 'Errors'
    }
  ];

  const getMessage = () => {
    let messageText = '';
    if (failure) {
      messageText = 'correct errors and upload again';
      return messageText;
    }
    if (warning) {
      messageText = 'view SKU Details and warnings';
      return messageText;
    }
    return 'view SKU Details';
  };

  const handleDownload = (event) => {
    event.preventDefault();
    if (!fileUrl) return;
    DownloadViaLink(fileUrl, fileUrl.split('/').pop()?.split('?')[0] || 'upload-result.csv');
  };

  return (
    <Space direction="vertical">
      {!!(failure || warning || success || total) && (
        <Space wrap>
          {tags.map(
            (tag) =>
              tag.number > 0 && (
                <Tag size="large" className="status_tags" color={tag?.color}>
                  <Space className="upload-info" size="large">
                    <span className="center gap-5">
                      {tag.icon} <Text>{tag.text}</Text>
                    </span>
                    <span>{tag.number}</span>
                  </Space>
                </Tag>
              )
          )}
        </Space>
      )}
      <Text>
        <Link className="accent-color" href={fileUrl} onClick={handleDownload}>
          Download File
        </Link>{' '}
        to {getMessage()}
      </Text>
    </Space>
  );
}

export default UploadSummary;
